module.exports = __webpack_public_path__ + "img/bottom-text.bbd98005.png";